import React from 'react';
import { motion } from 'framer-motion';
import ReactECharts from 'echarts-for-react';

const MedicineChart = () => {
  // Mock data for the last 7 days
  const chartData = {
    dates: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    taken: [8, 7, 8, 6, 8, 8, 5],
    scheduled: [8, 8, 8, 8, 8, 8, 8],
    missed: [0, 1, 0, 2, 0, 0, 3]
  };

  const option = {
    title: {
      text: 'Weekly Medicine Adherence',
      textStyle: {
        fontSize: 18,
        fontWeight: 'bold',
        color: '#1f2937'
      }
    },
    tooltip: {
      trigger: 'axis',
      backgroundColor: 'rgba(255, 255, 255, 0.95)',
      borderColor: '#e5e7eb',
      borderWidth: 1,
      textStyle: {
        color: '#374151'
      }
    },
    legend: {
      data: ['Taken', 'Scheduled', 'Missed'],
      bottom: 0,
      textStyle: {
        color: '#6b7280'
      }
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '15%',
      top: '15%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: chartData.dates,
      axisLine: {
        lineStyle: {
          color: '#e5e7eb'
        }
      },
      axisLabel: {
        color: '#6b7280'
      }
    },
    yAxis: {
      type: 'value',
      axisLine: {
        lineStyle: {
          color: '#e5e7eb'
        }
      },
      axisLabel: {
        color: '#6b7280'
      },
      splitLine: {
        lineStyle: {
          color: '#f3f4f6'
        }
      }
    },
    series: [
      {
        name: 'Taken',
        type: 'bar',
        data: chartData.taken,
        itemStyle: {
          color: '#10b981',
          borderRadius: [4, 4, 0, 0]
        }
      },
      {
        name: 'Scheduled',
        type: 'line',
        data: chartData.scheduled,
        lineStyle: {
          color: '#3b82f6',
          width: 3
        },
        itemStyle: {
          color: '#3b82f6'
        },
        symbol: 'circle',
        symbolSize: 6
      },
      {
        name: 'Missed',
        type: 'bar',
        data: chartData.missed,
        itemStyle: {
          color: '#ef4444',
          borderRadius: [4, 4, 0, 0]
        }
      }
    ]
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.3 }}
      className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6"
    >
      <div className="h-80">
        <ReactECharts 
          option={option} 
          style={{ height: '100%', width: '100%' }}
          opts={{ renderer: 'svg' }}
        />
      </div>
      
      {/* Insights */}
      <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="text-center p-4 bg-green-50 rounded-xl">
          <div className="text-2xl font-bold text-green-600">92%</div>
          <div className="text-sm text-green-700">Adherence Rate</div>
        </div>
        <div className="text-center p-4 bg-blue-50 rounded-xl">
          <div className="text-2xl font-bold text-blue-600">50</div>
          <div className="text-sm text-blue-700">Total Taken</div>
        </div>
        <div className="text-center p-4 bg-red-50 rounded-xl">
          <div className="text-2xl font-bold text-red-600">6</div>
          <div className="text-sm text-red-700">Missed Doses</div>
        </div>
      </div>
    </motion.div>
  );
};

export default MedicineChart;